// This has emptied out results i.e. is static
const STATIC_FLAT_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT_static.json';

// Results from either Decision Desk or Secretary of State (depending on what the cron job is collecting)
const FLAT_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT.json';

// Results from the final canvass 
const FINAL_RESULTS_URL = `https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT_FINAL.json`

// Includes fake results data for testing
const FAKE_RESULTS_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT_dummy_data.json';
const FAKE_RESULTS_URL_TWO =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT_TEST_OCT_8.json';

// fake results based on 2018 returns for Senate and Governor
const FAKE_RESULTS_2018 =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/republic_json/results_FLAT_dummy_data_2018.json';

// Used for homepage takeover
const HOMEPAGE_URL =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2020_general/homepage_takeover/2020-general.json';

// This is for the other candidates for the hide/show toggle. I turned it off by making it a really high number, you can turn it back on by making it 3
const visibleCandidatesCount = 53;

// Show countdown counter, set to true to last updated text
const showCountdown = false;

// Show precincts or estimated votes still being counted text
const showPrecinctsReporting = false;

// Switches front-end to show either 'Decision Desk HQ' as source or 'Texas Secretary of State'
const source = 'Decision Desk HQ';

// Adds the checkmark if this is the final official results from local canvass
const isCanvass = true;

// Calls TT stories using the API
const STORY_API_URL = (id: number): string =>
  `https://www.texastribune.org/api/v2/articles/${id}/?format=json&fields=sitewide_image,summary,authors,url,pub_date,updated_date,homepage_headline`;

// What we are using across the ap
// will be used on the results page, in the homepage takeover
// and in the embeds
const RESULTS_IN_USE = FINAL_RESULTS_URL;

export {
  RESULTS_IN_USE,
  HOMEPAGE_URL,
  STORY_API_URL,
  visibleCandidatesCount,
  showCountdown,
  showPrecinctsReporting,
  isCanvass,
  source,
};
